import React from 'react';

import { flagStyles } from '../settings';

const SvgEU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1632px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgEU;
